import BaseModel from '../base/BaseModel.model';
export default class UserDocument extends BaseModel {
   public documentId?:number;
   public document:any;
   public user:any;
   public userId?:number;
   public contentTypeName:string;
    init(){
        this.documentId = 0;   
        this.userId = 0;
        this.contentTypeName = '';
    }
}